import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../api/config';
import { useAddOrganizationResourceMutation } from '../../../api/mutations/add/use-add-organization-resource-mutation';
import { useEditOrganizationResourceMutation } from '../../../api/mutations/edit/use-edit-organization-resource-mutation';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import type { LocationGroup, ResourceTypeManagement } from '../../../types';
import { ResourcePage } from '../resource-page';
import { EditCreateLocationGroup } from './edit-create-location-group';
import { useLocationGroupColumns } from './use-location-group-columns';

export const LocationGroupManagement = () => {
    const { data: locationGroups, isLoading } = useOrganizationQuery<LocationGroup[]>(OrgQueryKeys.locationGroups);
    const { mutateAsync: addLocationGroup, isLoading: isCreating } = useAddOrganizationResourceMutation(OrgQueryKeys.locationGroups, L.locationGroup());
    const { mutateAsync: editLocationGroup, isLoading: isUpdating } = useEditOrganizationResourceMutation(OrgQueryKeys.locationGroups, L.locationGroup());
    const columns = useLocationGroupColumns();

    return (
        <ResourcePage
            resourceType='locationGroup'
            isLoading={isLoading || isCreating || isUpdating}
            titleFunc={(locationGroup: ResourceTypeManagement) => locationGroup.name}
            data={locationGroups}
            columns={columns}
            EditCreateComponent={(editCreateProps: { resource: ResourceTypeManagement, closeModal: () => void }) =>
                <EditCreateLocationGroup
                    existingLocationGroup={editCreateProps.resource as LocationGroup}
                    closeModal={editCreateProps.closeModal}
                    addLocationGroup={addLocationGroup}
                    editLocationGroup={editLocationGroup}
                />
            }
        />
    );
};
